import { Undefinable } from "@core/domain/types/undefinable.type";

export class UserEntity {
    constructor(
        public readonly id: Undefinable<number>,
        public readonly name: Undefinable<string>,
    ) {}
}
